export default __webpack_public_path__ + "static/media/datte_500.ed19ef0b.webp";